import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { NfFormsModule, ToastModule } from '@northfork/ng-basics'
import { DirectTransferComponent } from './direct-transfer.component'
import { ExchangeInOutFormComponent } from './exchange-in-out-form/exchange-in-out-form.component'
import { MvtCheckboxControlModule } from './mvt-checkbox-control/mvt-checkbox-control.module'
import { TransferInOutFormComponent } from './transfer-in-out-form/transfer-in-out-form.component'
import { DirectTransferSaveConfirmationModalComponent } from './direct-transfer-confirm-button-modal/direct-transfer-confirm-button-modal'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Third Party Dependencies
    NgbDropdownModule,
    NgSelectModule,

    // Northfork Dependencies
    NfFormsModule,
    NgbModalModule,
    ToastModule,

    // Helios Dependencies
    GenericComponentsModule,
    MvtCheckboxControlModule,
    TableLayoutModule,
  ],
  declarations: [
    DirectTransferComponent,
    ExchangeInOutFormComponent,
    TransferInOutFormComponent,
    DirectTransferSaveConfirmationModalComponent,
  ],
  exports: [DirectTransferComponent],
})
export class DirectTransferModule {}
